module.exports = __webpack_public_path__ + "img/fuceng.b7ebfa7b.png";